import React from 'react';
import { Link } from 'react-router-dom';

/**
 * Short CTA under a published expert note when we know the designer (profile link).
 */
export default function ExpertNoteFollowUpCta({ note, className = 'text-xs text-gray-600 mt-2 leading-snug' }) {
  const designerId = note?.designer_id;
  if (!designerId) return null;
  const to = `/find-designer?designer=${encodeURIComponent(designerId)}`;
  return (
    <p className={className}>
      Want to go further?{' '}
      <Link to={to} className="font-medium text-green-700 hover:underline">
        View profile
      </Link>{' '}
      to send a yard brief or get in touch.
    </p>
  );
}
